import React from 'react';

import CVDocument from '../document.component';
import { localizedPage, useLocalizedPage } from '../i18n/localized-page';

import english from './locales/terms.en';

// The license terms for both apps, and - while pricing is public - the
// CaptiVision Pro subscription terms Apple requires alongside the paywall. The
// English text applies; locales/ holds it and its translations.

const PAGES = localizedPage(english, code => import(/* webpackChunkName: "[request]" */ `./locales/terms.${code}`));

const CaptiVisionTerms = () => {
    const [page, lang] = useLocalizedPage(PAGES);

    return (
        <CVDocument
            lang={lang}
            title={page?.title}
            eyebrow={page?.eyebrow}
            lede={page?.lede}
            meta={page?.meta}
            note={page?.note}
            footerCurrent="Terms of Use">
            {page?.body}
        </CVDocument>
    )
}

export default CaptiVisionTerms;
